export const zeroPad = (value, padding = 2) => {
	let str = `${value}`
	while (str.length < padding) {
		str = `0${str}`
	}
	return str
}

export const toMinuteString = (seconds) => {
	seconds = Math.max(0, seconds)
	return `${zeroPad(Math.floor(seconds/60))}:${zeroPad(seconds%60)}`
}



// WEBPACK FOOTER //
// ./src/lib/StringUtil.js